import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import SellLeadFormInModal from "./SellLeadFormInModal";
import { withTranslation } from 'react-i18next';

class SellLeadModal extends Component {
    constructor(props) {
        super(props);
        this.handleFormSubmitted = this.handleFormSubmitted.bind(this);
    }

    handleFormSubmitted(leadId, amount) {
        this.props.onSubmit(leadId, amount);
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <Modal isOpen={this.props.open} className={this.props.className}>
                    <ModalHeader>{t('sell_lead_modal.congratulations')} <span>{t('sell_lead_modal.question')}</span></ModalHeader>
                    <SellLeadFormInModal leadId={this.props.leadId} onSubmit={this.handleFormSubmitted}/>
                </Modal>
            </div>
        );
    }
}

export default withTranslation()(SellLeadModal);

